import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IExportPdfBaseSettings} from "@containers/export/containers/pdf/types";
import {IExportDataSetItem} from "@containers/export/containers/buildData/hooks/types/exportParams";

export const getPageSizeByColumnSize = (size: number): IExportPdfBaseSettings => {
    if (size < 300) {
        return {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            fontSize: 10
        }
    }
    if (size < 596) {
        return {
            pageSize: {
                width: size + 22,
                height: 'auto'
            },
            pageOrientation: 'portrait',
            fontSize: 10
        }
    }

    return {
        pageSize: {
            width: size + 20,
            height: 'auto'
        },
        pageOrientation: 'auto',
        fontSize: 10
    }
}

const buildSettingsByColumnLength = (length: number): IExportPdfBaseSettings => {

    if (!length || length <= 3) {
        return {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            fontSize: 10,
        }
    }

    if (length < 5) {
        return {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            fontSize: 10,
        }
    }

    if (length <= 7) {
        return {
            pageSize: 'A3',
            pageOrientation: 'portrait',
            fontSize: 8,
            tableHeader: {
                fontSize: 8
            }
        }
    }

    if (length <= 9) {
        return {
            pageSize: 'A2',
            pageOrientation: 'portrait',
            fontSize: 8,
            tableHeader: {
                fontSize: 8
            }
        }
    }

    return {
        pageSize: 'A1',
        pageOrientation: 'landscape',
        fontSize: 7,
    }
}

const generateExportStylesPdfBaseSettingsByColumns = (columns: IColumnItem<any>[]): IExportPdfBaseSettings => {
    const length = columns.length;
    let sizeColumns = 0;
    let autoSize = true;
    if (columns.length) {
        columns.forEach((item, index, array) => {

            if (item?.exportStyles?.pdf?.width === '*' || item?.exportStyles?.pdf?.width) {
                autoSize = false;
            }

            sizeColumns += Number(item?.exportStyles?.pdf?.width ?? 40)
            if (index !== array.length - 1) {
                sizeColumns += 10
            }

        })

    }

    if (!autoSize) {
        return getPageSizeByColumnSize(sizeColumns)
    }

    return buildSettingsByColumnLength(length)

}

export const generateExportStylesPdfBaseSettings = (
    columns: IColumnItem<any>[],
    dataSet: IExportDataSetItem<any>
): IExportPdfBaseSettings => {
    return generateExportStylesPdfBaseSettingsByColumns(columns)


}